import React from "react";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import "./headboard-breadcrumbs.scss";
import HeadboardBreadcrumbsProps from "./headboard-breadcrumbs.types";
const HeadboardBreadcrumbs = ({ breadcrumb }: HeadboardBreadcrumbsProps) => {
  return (
    <div className="o-headboard-breadcrumbs">
      <div className="o-headboard-breadcrumbs__container">
        {breadcrumb && (
          <div className={`o-headboard-breadcrumbs__migadepan`}>
            <Breadcrumb content={breadcrumb} />
          </div>
        )}
      </div>
    </div>
  );
};
export default HeadboardBreadcrumbs;
